import React from 'react'

const Paragraph = ({ children, classe }) => {
	return (
		<p className={`${classe} text-sm md:text-base font-nunito opacity-50`}>
			{ children }
		</p>
	)
}

export default Paragraph